import { lazy, Suspense } from "react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import { useOrder } from "@/components/SiteLayout";

const LandingSections = lazy(() => import("@/pages/LandingSections"));

export default function Landing() {
  const openOrder = useOrder();
  return (
    <>
      <Hero onOrder={openOrder} />
      <Marquee />
      <Suspense fallback={null}>
        <LandingSections />
      </Suspense>
    </>
  );
}
